import z from 'zod'
import { ApiSecretRequiredException } from '../../errors'
import type { FetchSubTypes } from '../../types'
import { createClient } from '../createClient'

export const fetchSubTypes: FetchSubTypes = async ({
  apiKey,
  apiSecret,
  createHeaders,
  proxy,
}) => {
  if (!apiSecret) {
    throw new ApiSecretRequiredException()
  }

  const client = createClient({
    apiKey,
    apiSecret,
    createHeaders,
    proxy,
  })

  const response = await client.run({
    method: 'GET',
    path: '/v1/user/assets',
    responseSchema,
  })

  const subTypes = new Set<string>()
  for (const asset of response.data.assets) {
    subTypes.add(asset.asset)
  }

  return [...subTypes].sort((a, b) => a.localeCompare(b))
}

const responseSchema = z.object({
  data: z.object({
    assets: z.array(
      z.object({
        asset: z.string(),
      }),
    ),
  }),
})
